export default theme => {
  return {
    container: {
      height: '100%',
    },
    h0: {
      backgroundColor: theme.palette.grey[200],
      height: '100%',
      // textAlign: 'center',
      paddingTop: 0,
      paddingLeft: 10
    },
    d0: {
      marginTop: 5,
      marginBottom: 5,
      paddingLeft: 15,
      paddingRight: 5
    },
    metricsLabelText: {
      padding: 2
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/configuration/FidelityV2/theme/components/scorecard/ScorecardView/ScorecardScroller/ScorecardFixedColumn/ScorecardMetricsLabels.js